import {formatMasks} from './formatMasks';

export function validateCEP(cep: string): boolean {
	return /^\d{8}$/.test(formatMasks('clear', cep));
}
